<template>
  <div class="single-obituary-comment-landing" />
</template>

<script>
  import { mapActions, mapState } from "vuex";

  export default {
    name: "SingleCommentLandingPageModal",

    data() {
      return {
        commentId: this.$mountEl.dataset.commentId,
        hasOpened: false,
        possessiveName: this.$mountEl.dataset.possessiveName || "",
        deceasedName: this.$mountEl.dataset.deceasedName || "",
      };
    },

    computed: {
      ...mapState("comments", ["commentsList"]),
      ...mapState("singleCommentModal", { modalIsOpen: "isOpen" }),

      comment() {
        if (!(this.commentId && this.commentsList.length)) {
          return null;
        }

        return this.commentsList.find(({ id }) => id === this.commentId);
      },
    },

    watch: {
      comment: {
        immediate: true,
        handler(newComment, oldComment) {
          if (!newComment || newComment === oldComment || this.hasOpened) {
            return;
          }

          // Trigger the modal transition on the next tick.
          this.$nextTick(() => {
            this.hasOpened = true;
            this.openSingleCommentModal({
              context: "share",
              comment: newComment,
              hash: "",
              isNew: false,
              isLandingPage: true,
              deceasedName: this.deceasedName,
              possessiveName: this.possessiveName,
            });
          });
        },
      },

      modalIsOpen(newState) {
        if (newState || !this.hasOpened) {
          return;
        }

        this.updateUrl();
        this.removeFromDOM();
      },
    },

    methods: {
      ...mapActions("singleCommentModal", { openSingleCommentModal: "open" }),

      updateUrl() {
        const pathname = window.location.pathname;
        const newPathname = pathname.replace(`/${this.commentId}`, "");

        history.replaceState({ comment_id: this.commentId }, "", newPathname);
      },

      removeFromDOM() {
        setTimeout(() => {
          this.$mountEl.remove();
        }, 500);
      },
    },
  };
</script>
